import Vue from 'vue'
import App from './App_newlayout_test.vue'
// import App from './App_newlayout_constrained.vue'
import router from "./router";
import vuetify from "./plugins/vuetify";
import { store } from "./store/index";

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import "./utils/filters";

import cookieconsent from 'vue-cookieconsent-component';

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
    id: 'UA-173950148-1',
    router
})

Vue.component('cookie-consent', cookieconsent)

import "./utils/filters";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
